import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
} from '@mui/material';
import { Field, FieldProps } from 'formik';

export const CustomCheckbox = ({
  onChange,
  onBlur,
  ...propsRest
}: Omit<FormControlLabelProps, 'control'>) => {
  return (
    <Field name={propsRest.name} type="checkbox">
      {({ field, form: { touched, errors } }: FieldProps) => (
        <>
          <FormControlLabel
            {...propsRest}
            {...field}
            sx={{ mr: 1 }}
            onChange={e => {
              field.onChange(e);
              if (onChange) onChange(e, Boolean(field.checked));
            }}
            onBlur={e => {
              field.onBlur(e);
              if (onBlur) onBlur(e);
            }}
            control={<Checkbox checked={field.checked} />}
          />
          {touched[field.name] && Boolean(errors[field.name]) && (
            <FormHelperText error>{errors[field.name]}</FormHelperText>
          )}
        </>
      )}
    </Field>
  );
};
